import { PspContext } from "@/config/contexts";
import { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export function useTemplatesAndInstructionsMobile() {
  const { lang } = useContext(PspContext);
  const navigate = useNavigate();

  const searchBoxRef = useRef<HTMLInputElement>(null);

  const [isSearching, setIsSearching] = useState(false);

  function startSearchingMobile() {
    setIsSearching(true);
    setTimeout(() => {
      searchBoxRef.current?.focus();
    }, 0);
  }

  function onBack() {
    navigate(-1);
  }

  return {
    lang,
    onBack,
    isSearching,
    setIsSearching,
    searchBoxRef,
    startSearchingMobile,
  };
}
